import React from 'react';
import {
    FileText,
    Paperclip,
    Layout,
    Edit3,
    Eye
} from 'lucide-react';
import EntryTypeStep from './steps/EntryTypeStep';
//import AttachmentStep from './steps/AttachmentStep';
import TemplateSelectionStep from './steps/TemplateSelectionStep';
import DetailsEntryStep from './steps/DetailsEntryStep';
import PreviewStep from './steps/PreviewStep';

import { useHistory } from 'react-router-dom';

const STEPS = {
    ENTRY_TYPE: 'step_1_entry_type',
    //ATTACHMENTS: 'step_2_attachments',
    TEMPLATE: 'step_3_template',
    DETAILS: 'step_4_details',
    PREVIEW: 'step_5_preview'
};

const BookkeepingStepContent = ({
    activeStep,
    entry,
    setEntry,
    templates,
    accounts,
    templatesLoading,
    accountsLoading,
    templatesError,
    accountsError,
    companyId,
    handleTemplateSelect,
    fetchTemplates,
    getAccountByNumber,
    getAccountsByType,
    searchAccounts,
    operationInProgress
}) => {
    const history = useHistory();

    const getStepConfig = (step) => {
        const configs = {
            [STEPS.ENTRY_TYPE]: {
                title: 'Välj Posttyp',
                description: 'Välj vilken typ av bokföringspost du vill skapa',
                icon: FileText
            },
            [STEPS.ATTACHMENTS]: {
                title: 'Lägg till Bilagor',
                description: 'Ladda upp kvitton, fakturor eller andra dokument (valfritt)',
                icon: Paperclip
            },
            [STEPS.TEMPLATE]: {
                title: 'Välj Mall',
                description: 'Välj en mall som passar din bokföringspost',
                icon: Layout
            },
            [STEPS.DETAILS]: {
                title: 'Fyll i Detaljer',
                description: 'Ange beskrivning, datum och andra nödvändiga uppgifter',
                icon: Edit3
            },
            [STEPS.PREVIEW]: {
                title: 'Granska och Skapa',
                description: 'Kontrollera att allt ser korrekt ut innan du skapar verifikatet',
                icon: Eye
            }
        };
        return configs[step] || configs[STEPS.ENTRY_TYPE];
    };

    const renderStepContent = () => {
        switch (activeStep) {
            case STEPS.ENTRY_TYPE:
                return (
                    <EntryTypeStep
                        selectedType={entry.entryType}
                        onSelect={(type) => setEntry({ ...entry, entryType: type })}
                        onManualEntry={() => history.push(`/${companyId}/manual-bookkeeping-entry`)}
                    />
                );



            case STEPS.TEMPLATE:
                return (
                    <TemplateSelectionStep
                        entryType={entry.entryType}
                        selectedTemplate={entry.template}
                        onSelect={handleTemplateSelect}
                        templates={templates}
                        loading={templatesLoading}
                        error={templatesError}
                        onRetry={fetchTemplates}
                    />
                );

            case STEPS.DETAILS:
                return (
                    <DetailsEntryStep
                        entry={entry}
                        onChange={(updatedEntry) => setEntry(updatedEntry)}
                        companyId={companyId}
                        accounts={accounts}
                        accountsLoading={accountsLoading}
                        accountsError={accountsError}
                        getAccountByNumber={getAccountByNumber}
                        getAccountsByType={getAccountsByType}
                        searchAccounts={searchAccounts}
                    />
                );

            case STEPS.PREVIEW:
                return (
                    <PreviewStep
                        entry={entry}
                        onChange={(updatedEntry) => setEntry(updatedEntry)}
                        templates={templates}
                        accounts={accounts}
                        accountsLoading={accountsLoading}
                        accountsError={accountsError}
                        getAccountByNumber={getAccountByNumber}
                        getAccountsByType={getAccountsByType}
                        searchAccounts={searchAccounts}
                    />
                );

            default:
                return null;
        }
    };

    const stepConfig = getStepConfig(activeStep);

    return (
        <>
            <style>{`
                .step-content-container {
                    background: white;
                    border-radius: 12px;
                    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
                    border: 1px solid #e5e7eb;
                    overflow: hidden;
                    margin-bottom: 2rem;
                }
                
                .step-header {
                    background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
                    padding: 2rem;
                    border-bottom: 1px solid #e5e7eb;
                }
                
                .step-title {
                    align-items: center;
                    gap: 1rem;
                    margin-bottom: 0.5rem;
                }
                
                .step-title h3 {
                    font-size: 1.5rem;
                    font-weight: 600;
                    color: #1e293b;
                    margin: 0;
                }
                
                .step-description {
                    color: #64748b;
                    font-size: 0.875rem;
                    line-height: 1.5;
                    margin: 0;
                }
                
                .step-body {
                    padding: 2rem;
                }
                
                @media (max-width: 768px) {
                    .step-header,
                    .step-body {
                        padding: 1.5rem;
                    }
                    
                    .step-title h3 {
                        font-size: 1.25rem;
                    }
                }
            `}</style>

            <div className="step-content-container">
                <div className="step-header">
                    <div className="step-title">
                        <stepConfig.icon size={24} color="#3b82f6" />
                        <h3>{stepConfig.title}</h3>
                    </div>
                    <p className="step-description">{stepConfig.description}</p>
                </div>

                <div className="step-body">
                    {renderStepContent()}
                </div>
            </div>
        </>
    );
};

export default BookkeepingStepContent;